var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.5C16.5795 7.5 15.833 8.24652 15.833 9.16699V11.667C15.833 14.3333 15.833 15.6663 15.0449 16.5264C14.986 16.5907 14.9247 16.653 14.8604 16.7119C14.0002 17.5001 12.6666 17.5 10 17.5C7.33335 17.5 5.99978 17.5001 5.13965 16.7119C5.07533 16.653 5.01402 16.5907 4.95508 16.5264C4.16703 15.6663 4.16699 14.3333 4.16699 11.667V9.16699C4.16699 8.24652 3.42047 7.5 2.5 7.5V5H17.5V7.5ZM7.91699 8.16699C7.36471 8.16699 6.91699 8.61471 6.91699 9.16699V13.334C6.91734 13.886 7.36492 14.334 7.91699 14.334C8.46891 14.3338 8.91664 13.8859 8.91699 13.334V9.16699C8.91699 8.61482 8.46913 8.16717 7.91699 8.16699ZM12.084 8.16699C11.5317 8.16699 11.084 8.61471 11.084 9.16699V13.334C11.0843 13.886 11.5319 14.334 12.084 14.334C12.6358 14.3336 13.0836 13.8858 13.084 13.334V9.16699C13.084 8.61492 12.636 8.16734 12.084 8.16699Z",
    fill: "#9061DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3902 2.80883C8.48516 2.72023 8.69441 2.64194 8.98548 2.5861C9.27655 2.53027 9.63319 2.5 10.0001 2.5C10.367 2.5 10.7236 2.53027 11.0147 2.5861C11.3058 2.64194 11.515 2.72023 11.61 2.80883",
    stroke: "#9061DB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon);
export default __webpack_public_path__ + "static/media/deleteicon.ba9b45bd4d46313054566d224d05a1d6.svg";
export { ForwardRef as ReactComponent };